<template>
    <div class="content mt20">
        <div class="account-content bgfff">
            <!-- 导航 -->
            <matrixMenu></matrixMenu>
        </div>
        <div class="bgfff mt20" v-if="!success">
            <h1 class="title">文章发布</h1>
            <div class="clearfix">
                <div class="article-content">
                    <p class="article-t">选择发布媒体号</p>
                    <ul class="article-ul clearfix">
                        <li v-for="(item,index) in selectList" :key="index">
                            <div class="article-li">
                                <div class="account-img"><img :src="item.profileImgUrl" onerror="this.src='static/images/headImg.png'" /></div>
                                <a class="icons close-icon" href="javascript:void(0);" @click="delSelectUser(item.id);"></a>
                                <i class="icons" :class="platformImg[item.type-1]"></i>
                                <p class="fs12 ac">{{item.screenName}}</p>
                            </div>
                        </li>
                        <li class="last">
                            <div class="article-li cp" @click="addSendMedia();">
                                <div class="article-bigAdd">
                                    <i class="icons bigAdd-icon"></i>
                                </div>
                                <p class="fs12 ac color-blue">添加账号</p>
                            </div>
                        </li>
                    </ul>
                </div>
                <!-- <div class="article-content">
                    <p class="article-t">2. 选择审核人（如无需审核可不选择）</p>
                    <ul class="article-ul more clearfix">
                        <li class="artic-arrow" v-for="(item,index) in peopleList" :key="index">
                            <div class="article-li">
                                <div class="" v-for="(items,index) in item" :key="index">
                                    <div class="account-img"><img :src="items.picurl"></div>
                                    <a class="icons close-icon" href="javascript:void(0);" @click="delSelectPeople(items.id);"></a>
                                    <p class="fs12 ac">{{items.nickname}}</p>
                                </div>
                            </div>
                        </li>
                        <li class="last">
                            <div class="article-li cp" @click="addPeople();">
                                <div class="article-bigAdd">
                                    <i class="icons bigAdd-icon"></i>
                                </div>
                                <p class="fs12 ac color-blue">添加账号</p>
                            </div>
                        </li>
                    </ul>
                </div> -->
                <div class="btn-div mt20 ml20 clearfix">
                    <button class="btn btn-blue fl" @click="enterPublish();">提交</button>
                    <router-link class="btn ac btn-white ml20 fl" to="/materialCenter/myMaterial">返回</router-link>
                </div>
            </div>
        </div>
        <div class="bgfff mt20" v-if="success">
            <h1 class="title">文章发布</h1>
            <div class="clearfix">
                <div class="article-finish ac">
                    <div class="article-fp mt30">
                        <i class="icons sucess-icon"></i>
                        <p class="color-gray mt10">发布完成！</p>
                    </div>
                    <div class="btn-div mt50 article-return">
                        <span class="color-gray">{{second}}s后自动返回</span>
                        <router-link class="btn ac btn-blue ml20" to="/materialCenter/myMaterial">点击跳转</router-link>
                    </div>
                </div>
            </div>
        </div>
        <!-- 选择发布媒体号 -->
        <mediaSelect ref="invitationToGroup" :dataArray="list2" :listPass='true' @userCallback="invitationToGroup" v-if="list2 != ''"></mediaSelect>
        <!-- 添加审核人 -->
        <peopleSelect ref="peopleGroup" :dataArray="list1" :listPass='true' @peopleCallback="peopleSave" v-if="list1 != ''"></peopleSelect>
  	</div>
</template>
<script>
import Dialog from '../../components/dialog.vue';
import matrixMenu from './matrixMenu.vue';
import mediaSelect from '../../components/mediaSelect.vue';
import peopleSelect from '../../components/peopleSelect.vue';
export default {
    components:{Dialog,matrixMenu,mediaSelect,peopleSelect},
    data() {
        return {
            platformImg:['wx-icon','wb-icon','tt-icon'],
            articleId:'',
            success:false,//控制发布状态显示
            second:6,//倒计时
            list1:[],//审核人列表
            list2:[],//媒体列表
            mediaIds:[],//账户id
            peopleIds:[],//账户id
            selectList:[],//已选列表
            peopleList:[]//已选用户列表
        }
    },
    mounted() {
        let that = this;
        that.$nextTick(()=> {
            that.articleId = that.$route.query.id;
            // that.getUesrList();
            that.getMediaList();
        })
    },
    created() {
		
    },
    methods: {
        // 获取账户列表
        getUesrList () {
            let that = this;
            let url = 'user/checklist';
            that.allIds = [];
            that.$api.post(url, {search:''}, r => {
                that.$parent.returnCode(r,function(){
                    that.list1 = r.data;
                })
            })
        },
        // 获取媒体列表
        getMediaList () {
            let that = this;
            let url = 'member/publishlist';
            that.$api.post(url, {other:0}, r => {
                that.$parent.returnCode(r,function(){
                    that.list2 = r.data;
                })
            })
        },
        // 添加发布账号
        addSendMedia () {
            this.$refs.invitationToGroup.synchroPublicNumber(2,'选择账号');
            this.$refs.invitationToGroup.mediaIds = this.mediaIds;
        },
        invitationToGroup (val) {
            this.mediaIds = val[0];
            this.selectList = val[1];
        },
        // 
        addPeople () {
            this.$refs.peopleGroup.synchroPublicNumber();
            this.$refs.peopleGroup.ids = this.peopleIds;
        },
        // 保存选择人
        peopleSave (val) {
            this.peopleIds = val[0];
            this.peopleList.push(val[1]);
        },
        // 删除已选发布媒体号
        delSelectUser (id) {
            let mediaIds = this.mediaIds;
            let selectList = this.selectList;
            let index = '';
            for(let i in selectList){
                if(id === selectList[i].id){
                    index = i;
                }
            }
            selectList.splice(index,1);
            mediaIds.splice(index,1);
        },
        // 删除已选账号
        delSelectPeople (id) {
            let peopleIds = this.peopleIds;
            let peopleList = this.peopleList;
            for(let i in peopleIds){
                for(let k in peopleIds[i]){
                    if(id === peopleIds[i][k]){
                        peopleIds[i].splice(k,1);
                        peopleList[i].splice(k,1);
                        if(peopleIds[i].length <= 0){
                            peopleIds.splice(i,1);
                            peopleList.splice(i,1);
                        }
                    }
                }
            }
        },
        // 确认发布
        enterPublish () {
            let that = this;
            if(that.mediaIds.length <= 0){
                that.$utils.alertText('请选择发布媒体账号');
                return;
            }
            let id = [];
            for(let i of that.mediaIds){
                let arr = [];
                let zhi = i.split('-');
                arr.push(zhi[0],zhi[1]);
                id.push(arr);
            }
            that.$parent.loadModal(true,'提交数据中...');
            that.$api.post('editor/publish', {accountid:id,pid:that.articleId}, r => {//,checkuserid:that.peopleIds
                that.$parent.showLoad = false;
                that.$parent.returnCode(r,function(){
                    that.success = true;
                    that.countDown();
                })
            })
        },
        //倒计时
        countDown () {
            let that = this;
            that.second--;
            if(that.second <= 0){
                that.$router.push({path:'/materialCenter/myMaterial'});
                return;
            }
            setTimeout(() => {
                that.countDown();
            }, 1000);
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/page/materialCenter/matrixArticle.vue